/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useMemo } from 'react';
import { Button, Tooltip } from '@mui/material';
import { useDispatch } from 'react-redux';
import { openDialog } from '@/features/dialog/dialogSlice';
import { Add } from '@mui/icons-material';
import { useParams } from 'react-router-dom';
import { AI_SUMMARY_TYPES } from '@/features/factFind/factFindApi';
import { AI_WORKFLOW_STATUSES } from '@/features/aiWorkflow/constants';
import useGetAIWorkflows from '@/hooks/useGetAIWorkflows';

export const AddQuoteButton = () => {
	const dispatch = useDispatch();

	const { dealId } = useParams();

	const workflowType = AI_SUMMARY_TYPES.quoteSummary;
	const { getLatestWorkflow } = useGetAIWorkflows({ dealId });
	const latestWorkflow = getLatestWorkflow(workflowType);

	const isGenerating =
		latestWorkflow &&
		![AI_WORKFLOW_STATUSES.ERROR, AI_WORKFLOW_STATUSES.SUCCESS].includes(
			latestWorkflow?.status,
		);

	return (
		<Tooltip title={isGenerating ? 'Generating quote data ...' : ''}>
			<div>
				<Button
					variant='tab_header'
					startIcon={<Add />}
					disabled={isGenerating}
					onClick={() => {
						dispatch(openDialog('quote'));
					}}
				>
					{'Add Quote'}
				</Button>
			</div>
		</Tooltip>
	);
};
